import noise from '@/scripts/noise';

class AudioLine {
  constructor(canvas) {
    this.canvas = canvas || document.querySelector('.wave-canvas');
    this.ctx = canvas.getContext('2d');
    this.width = 45;
    this.height = 45;
    this.rows = 0;
    this.scale = 120;
    this.lines = [];
    this.dpi = window.devicePixelRatio > 1.5 ? 2 : 1;
    this.offsetTop = 0;
    this.line = null;
    this.dots = [];
    this.speedLine = 1;
    this.lineColor = '255, 255, 255';
    this.opacity = 0.7;
  }

  init() {
    this.rows = Math.floor(this.height / this.scale);

    this.offsetTop = this.height - (300 * this.scale);

    this.width = this.width * this.dpi;
    this.height = this.height * this.dpi;

    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.canvas.style.width = `${this.width}px`;
    this.canvas.style.height = `${this.height}px`;

    for (let x = -1; x < this.width / (2 * this.dpi); x += 1) {
      this.dots.push([x * 2, this.height / 2]);
    }
    this.line = this.createLine();
  }

  createLine() {
    this.objLine = {
      dots: this.dots,
      space: 10,
      offset: Math.random(),
      height: Math.random(),
      speed: 1,
    };

    this.ctx.lineWidth = 2;

    this.drawLine();
  }

  drawLine() {
    if (this.dots.length === 0) return;
    this.objLine.offset += (this.objLine.speed * 0.004);
    this.ctx.globalAlpha = 1;
    this.ctx.beginPath();
    this.ctx.moveTo(this.objLine.dots[0][0], this.objLine.dots[0][1]);

    for (let i = 0; i < this.objLine.dots.length; i += 1) {
      const x = this.dots[i][0];

      let multiplier = 1;
      if (x < this.objLine.space) multiplier = 1 / this.objLine.space * (x % this.objLine.space);
      // eslint-disable-next-line max-len
      if (x > (this.width - this.objLine.space)) multiplier = 1 / this.objLine.space * ((45 - x) % this.objLine.space);

      // eslint-disable-next-line max-len
      const y = this.dots[i][1] + noise.noise.simplex3(x * 0.02, 0, this.objLine.offset) * 10 * multiplier * this.objLine.speed;

      this.ctx.lineTo(x, y);
    }

    this.ctx.strokeStyle = `rgba(${this.lineColor},${this.opacity})`;
    this.ctx.stroke();
  }

  render() {
    this.ctx.clearRect(0, 0, this.width, this.height);

    this.drawLine();
  }

  get color() {
    return this.lineColor;
  }

  set color(color) {
    this.lineColor = color;
  }

  get speed() {
    return this.objLine.speed;
  }

  set speed(speed) {
    this.objLine.speed = speed;
  }

  resize() {
    this.init();
  }
}

export default AudioLine;
